import { Button } from "common/components/ui/Button";
import { DialogDescription, DialogTitle } from "common/components/ui/Dialog";
import { DrawerDescription, DrawerTitle } from "common/components/ui/Drawer";
import useWorkspaceAccountMutations from "common/datahooks/useWorkspaceAccountMutations";
import useTwBreakpoint from "common/hooks/useTwBreakpoint";

interface DeleteAccountProps {
  accountId: string;
  accountFullname: string;
  goBack: () => void;
  onSuccess: () => void;
}

export default function DeleteAccount({
  accountId,
  accountFullname,
  goBack,
  onSuccess,
}: DeleteAccountProps) {
  const isDesktop = useTwBreakpoint("lg");

  const { deleteAccount, isDeletingAccount } = useWorkspaceAccountMutations();

  function onClick() {
    deleteAccount({ accountId }).then(onSuccess);
  }

  const Title = isDesktop ? DialogTitle : DrawerTitle;
  const Description = isDesktop ? DialogDescription : DrawerDescription;

  return (
    <>
      <Title>{`Delete "${accountFullname}"?`}</Title>
      <Description className="mb-8">
        This will permanently remove this LinkedIn account from your workspace,
        and you will lose access to all of their leads, campaigns and
        conversations
      </Description>
      <div className="flex gap-x-2.5 justify-between">
        <Button
          onClick={goBack}
          variant="secondary-black"
          disabled={isDeletingAccount}
          className="lg:flex-1"
          size={isDesktop ? "md" : "lg"}
        >
          Cancel
        </Button>
        <Button
          isLoading={isDeletingAccount}
          onClick={onClick}
          variant="outline-danger"
          size={isDesktop ? "md" : "lg"}
          className="lg:flex-1"
        >
          Delete account
        </Button>
      </div>
    </>
  );
}
